import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'
import { getFormValues } from 'redux-form'
import {comboDireccionCliente, comboDireccionClienteSecundaria, comboClienteSecundarioActivo, comboTransportistasCliente, comboRutaTransportistaCliente, comboVehiculosTransportistaDeterminado,
  comboConductoresTransportistaDeterminado, comboOperarioPredeterminado} from '../../actions/combos/combos'
import {abrirDetallesAlbaran, editarAlbaran, cerrarDetallesAlbaran, deleteModalAlbaranDosis, abrirDetallesAlbaranDosis, editarAlbaranEImprimirDatosAlbaran,
  imprimirDatosAlbaran, imprimirDatosAlbaranCliente, imprimirEtiquetaPDF, abrirModalAlbaranValidacionRfid, cerrarModalAlbaranValidacionRfid} from '../../actions/albaran/albaran'
import ModalAlbaran from '../../components/albaran/ModalAlbaran'
import {abrirDetallesPedido} from '../../actions/pedidosVenta/pedidosVenta'
import {fetchPanelControl} from '../../actions/panelControl/panelControl'


export function mapStateToProps (state) {
  return {
    ...state.albaran,
    auth: state.auth,
    panelControl: state.panelControl,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    paginaActual: state.common.paginaActual,
    combos: {
      comboCliente: state.combos.comboCliente,
      comboDireccionCliente: state.combos.comboDireccionCliente,
      comboDireccionClienteSecundaria: state.combos.comboDireccionClienteSecundaria,
      comboClienteSecundarioActivo: state.combos.comboClienteSecundarioActivo,
      comboTransportistasCliente: state.combos.comboTransportistasCliente,
      comboRutaTransportistaCliente: state.combos.comboRutaTransportistaCliente,
      comboVehiculosTransportistaDeterminado: state.combos.comboVehiculosTransportistaDeterminado,
      comboConductoresTransportistaDeterminado: state.combos.comboConductoresTransportistaDeterminado,
      comboTipoDosis: state.combos.comboTipoDosis,
      comboOperarioPredeterminado: state.combos.comboOperarioPredeterminado
    },
    formModalAlbaran: getFormValues('ModalAlbaran')(state)
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      abrirDetallesAlbaran,
      editarAlbaran,
      cerrarDetallesAlbaran,
      deleteModalAlbaranDosis,
      abrirDetallesAlbaranDosis,
      editarAlbaranEImprimirDatosAlbaran,
      imprimirDatosAlbaran,
      imprimirDatosAlbaranCliente,
      imprimirEtiquetaPDF,
      comboDireccionCliente,
      comboDireccionClienteSecundaria,
      comboClienteSecundarioActivo,
      /*comboRuta,
      comboEmpresaTransportista,
      comboConductoresTransportista,
      comboVehiculosTransportista,
      comboTipoDosis,*/
      abrirDetallesPedido,
      comboTransportistasCliente,
      comboRutaTransportistaCliente,
      comboVehiculosTransportistaDeterminado,
      comboConductoresTransportistaDeterminado,
      comboOperarioPredeterminado,
      fetchPanelControl,
      abrirModalAlbaranValidacionRfid,
      cerrarModalAlbaranValidacionRfid
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(ModalAlbaran)))